import React from 'react';
import {SVGList} from "../../assets/svg/SVGList";
import {RiRobot3Line} from "react-icons/ri";
import {IoIosArrowRoundBack, IoIosArrowRoundForward} from "react-icons/io";
import {IoChevronBack} from "react-icons/io5";
import {Link, useOutletContext} from "react-router-dom";
import {routes} from "../../utils/Routes";
import {FaHome} from "react-icons/fa";

export function TopBarNavigationCourse({clickCallback, nextChapter, prevChapter, productId, mode="course", disableAIBtn=false}) {

    const {courseId, product} = useOutletContext();

     return (
            <div className={"row py-2 px-4 bg-white border-bottom d-flex align-items-center sticky-top"}>
                {
                    mode === "course" ?
                        <div className={"col-1 text-dark d-flex"} >

                            <div className={"clickable"} onClick={() => clickCallback(0)}>
                                <SVGList size={36}/>
                            </div>

                            <div className={"clickable ms-2 "+(disableAIBtn ? "d-none": "")} onClick={() => clickCallback(1)}>
                                <RiRobot3Line size={36} className={"text-dark "}/>
                            </div>


                        </div>
                        :
                        <div className={"col-1 "}>
                            <Link to={`/products/${productId}`} className={"btn btn-success text-white d-flex align-items-center"}>
                                <IoChevronBack size={24}/>
                                <label>Produktinfo</label>
                            </Link>
                        </div>
                }


                <div className={"col"}>

                </div>


                <div className={"col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12"}>

                    <div className={"d-flex py-1"}>


                        {
                            prevChapter != null ?
                                <Link to={routes.chapterPageAbs(product.name, courseId, prevChapter.moduleName, prevChapter.chapterName, prevChapter.modulePage)}
                                   className={"btn btn-outline-secondary col me-2 text-decoration-none d-flex align-items-center justify-content-center"}>
                                    <IoIosArrowRoundBack className={"me-2"} size={24} />
                                    <label>{prevChapter.chapterName}</label>
                                </Link>
                            :
                                null
                        }

                        {
                            nextChapter != null ?
                                <Link to={routes.chapterPageAbs(product.name, courseId, nextChapter.moduleName, nextChapter.chapterName, nextChapter.modulePage)}
                                   className={"btn btn-dark col text-decoration-none text-white d-flex align-items-center justify-content-center"}>
                                    <label>
                                        {nextChapter.chapterName}
                                    </label>
                                    <IoIosArrowRoundForward className={"ms-2"} size={24} />
                                </Link>
                            :
                                null
                        }

                        <Link to={`/produkt/${product.name}/kurs`} className={"text-muted ms-3"}>
                            <FaHome size={36}/>
                        </Link>

                    </div>
                </div>
            </div>

        )




}